<!-- Clean Shadcn UI-style List Component -->
<aside class="list-panel" [class.collapsed]="collapsed">
  
  <!-- Header Section -->
  <header class="list-header">
    <div class="header-title">
      <i class="{{ config.headerConfig!.icon }} header-icon"></i>
      <h2>{{ config.headerConfig!.title!.label | translate }}</h2>
      <span class="item-count">{{ list.length }}</span>
    </div>
    
    @if (config.headerConfig!.actions) {
      <div class="header-actions">
        @for (action of config.headerConfig!.actions; track action; let i = $index) {
          <button 
            type="button"
            class="btn-action"
            [class.btn-primary]="i === 0"
            [class.btn-secondary]="i === 1"
            [class.btn-warning]="i === 2"
            (click)="onClickAction(action.type!, {})"
            [title]="(action.title | translate)">
            <i class="{{action.icon!}}"></i>
          </button>
        }
      </div>
    }
  </header>

  <!-- Filters Section -->
  <div class="list-filters">
    @if (canFilterDeleted) {
      <div class="filter-toggle-group">
        <mat-button-toggle-group [value]="false" (valueChange)="onDeletionFilterChange($event)">
          @for (option of deletedFilterOptions; track option) {
            <mat-button-toggle [value]="option.value">
              {{ option.label | translate }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    }

    @if (canFilter) {
      <form [formGroup]="formGroup" class="search-form">
        <div class="search-input-wrapper">
          <i class="fa-regular fa-magnifying-glass search-icon"></i>
          <app-form-input 
            [type]="'text'" 
            formControlName="search" 
            [name]="'search'" 
            [placeholder]="'common.filter.name'">
          </app-form-input>
        </div>
      </form>
    }
  </div>

  <!-- Custom content slot -->
  <ng-content select="[list-top]"></ng-content>

  <!-- List Content -->
  <div class="list-content">
    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner [diameter]="32"></mat-spinner>
        <span class="loading-text">{{ 'common.loading' | translate }}</span>
      </div>
    } @else if (list.length === 0) {
      <div class="empty-state">
        <i class="fa-regular fa-inbox empty-icon"></i>
        <span class="empty-text">{{ 'common.empty' | translate }}</span>
      </div>
    } @else {
      <ul class="items-list">
        @for (item of list; track item) {
          <li 
            class="list-item" 
            [class.selected]="currentChoose === item"
            [class.expired]="item.expired">
            
            <!-- Item Content -->
            <div 
              class="item-content"
              [class.centered]="isCenter"
              [style.color]="entity !== 'team' ? item.color : null"
              [style.background-color]="item.background"
              [title]="item | listItem:entity"
              (click)="onClick(item)">
              
              <!-- Team hierarchy indicator -->
              @if (entity === 'team') {
                @for (x of getTabs(item.name); track x) {
                  <i class="fa-light fa-arrow-turn-down-right hierarchy-icon" *ngIf="item.parent"></i>
                }
              }
              
              <!-- Team color indicator -->
              @if (entity === 'team' && item.color) {
                <span class="color-indicator" [style.background-color]="item.color"></span>
              }
              
              <!-- Item label -->
              <span class="item-label">{{ item | listItem:entity }}</span>
              
              <!-- Remember type badge -->
              @if (entity === 'remember' && item.type) {
                <span class="type-badge" [style.background-color]="item.type.color"></span>
              }
            </div>

            <!-- Item Actions -->
            <div class="item-actions">
              @if (!item.base && !item.deleted && !item.admin && entity !== 'absence') {
                <button 
                  type="button"
                  class="action-btn action-duplicate"
                  (click)="onClickAction(duplicate.type, item)"
                  [title]="('common.actions.duplicate') | translate">
                  @if (duplicateLoading) {
                    <mat-spinner [diameter]="16"></mat-spinner>
                  } @else {
                    <i class="{{duplicate.icon}}"></i>
                  }
                </button>

                <button 
                  type="button"
                  class="action-btn action-delete"
                  (click)="onClickAction(softDeleted.type, item)"
                  [title]="('common.actions.delete') | translate">
                  @if (deleteLoading) {
                    <mat-spinner [diameter]="16"></mat-spinner>
                  } @else {
                    <i class="{{softDeleted.icon}}"></i>
                  }
                </button>
              }

              @if (!item.base && item.deleted) {
                <button 
                  type="button"
                  class="action-btn action-restore"
                  (confirm)="onClickAction(restore.type, item)"
                  [title]="('common.actions.restore') | translate"
                  [confirmMessage]="restore.confirmMessage" 
                  [titleMessage]="restore.titleMessage">
                  @if (deleteLoading) {
                    <mat-spinner [diameter]="16"></mat-spinner>
                  } @else {
                    <i class="{{restore.icon}}"></i>
                  }
                </button>
              }
            </div>
          </li>
        }
        
        <!-- Load More -->
        @if (showLoadMore) {
          <li class="load-more-item">
            <button type="button" class="btn-load-more" (click)="loadMore()">
              <span>{{ 'common.load-more' | translate }}</span>
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</aside>

<!-- Floating Toggle Button -->
@if (canCollapse) {
  <button 
    type="button"
    class="floating-toggle" 
    [class.open]="!collapsed"
    [attr.aria-pressed]="!collapsed"
    [attr.aria-label]="collapsed ? 'Ouvrir la liste' : 'Fermer la liste'"
    (click)="toggleCollapsed()">
    <i class="fas" [class.fa-chevron-left]="!collapsed" [class.fa-chevron-right]="collapsed"></i>
    <span class="toggle-label">{{ collapsed ? 'Ouvrir' : 'Fermer' }}</span>
  </button>
}
